// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"762":"908a3c13","942":"917f9291"}[chunkId] + ".chunk.css";
};